var _g, _g2, _g3, _ellipse, _path, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _ellipse3, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1094,
    height: 811.38,
    viewBox: "0 0 1094 811.38",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "toy car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 450.62,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 490.14,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 529.67,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 391.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 430.86,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 470.38,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 312.29,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 351.81,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 391.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 253,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 292.52,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 332.05,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 450.62,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 490.14,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 529.67,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 391.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 430.86,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 470.38,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 312.29,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 351.81,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 391.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.64,
    y: 253,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.45,
    y: 292.52,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.27,
    y: 332.05,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 197.62,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 237.14,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 276.67,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 138.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 177.86,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 217.38,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 59.29,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 98.81,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 138.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 39.52,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 79.05,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 197.62,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 237.14,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 276.67,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 138.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 177.86,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 217.38,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 59.29,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 98.81,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 138.33,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 39.52,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 79.05,
    width: 130.73,
    height: 39.52,
    rx: 7.43,
    fill: "#0284c7",
    opacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.61,597.26a80.56,80.56,0,0,1-1.74,16.87c-.22,1-.46,2.07-.7,3.07-6.17,24.77-23.6,42.89-44.39,44-.69,0-1.39.06-2.11.06-22,0-40.58-19-46.71-45.08-.18-.7-.33-1.39-.48-2.09a80.56,80.56,0,0,1-1.74-16.87c0-35.39,21.9-64,48.93-64S348.61,561.87,348.61,597.26Z",
    transform: "translate(-53 -45.06)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,597.26a80.56,80.56,0,0,1-1.74,16.87c-.22,1-.46,2.07-.7,3.07-.74,0-1.46,0-2.19-.09a99.36,99.36,0,0,1-16-2.19,98.49,98.49,0,0,1-14.27,3.26,100.29,100.29,0,0,1-11.18,1c-1.26,0-2.52.07-3.78.07a102.12,102.12,0,0,1-13.4-.89,99,99,0,0,1-21-5.22,98.21,98.21,0,0,1-11.35,3c-.18-.7-.33-1.39-.48-2.09a80.56,80.56,0,0,1-1.74-16.87c0-35.39,21.9-64,48.93-64S348.61,561.87,348.61,597.26Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,477.93a99.07,99.07,0,0,0-10.65-44.82L384.8,451l50.51-29.7a99.37,99.37,0,0,0-74.72-42.59,99.69,99.69,0,0,0-7.75-10.27l-82.73,25.73,67.79-39.86a99.47,99.47,0,0,0-156.52,53l70.81,81.51L175.27,433.3a99.48,99.48,0,0,0,89,175.52A100,100,0,0,0,328,610.57a99.52,99.52,0,0,0,121-97.12c0-2.21-.08-4.4-.22-6.58A99.47,99.47,0,0,0,453,477.93Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.29,496.38a265,265,0,0,0-92.09-1.17c-34.55,5.72-69.87,18.29-103.67,9.1-19.83-5.4-37-17.88-56.35-24.8A106.81,106.81,0,0,0,141,476,99.52,99.52,0,0,0,264.3,608.82,100,100,0,0,0,328,610.57a99.52,99.52,0,0,0,121-97.12c0-2.21-.08-4.4-.22-6.58A98.49,98.49,0,0,0,451.29,496.38Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 547,
    cy: 699.6,
    rx: 547,
    ry: 99.5,
    fill: "#0284c7",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.68,756.13a19,19,0,0,1,29.42-11l.78.57c16.73,12.54,6.8,35.54,0,36.06S790,782.84,790,782.84,774.59,776.48,779.68,756.13Z",
    transform: "translate(-53 -45.06)",
    fill: "#192534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M930.62,740.5v4.18s-68,4.7-75.26,4.7H841.77s-.2.21-.53.59c-.56.63-1.51,1.74-2.56,3.12-2.14,2.78-4.69,6.66-5.28,9.88-1,5.75-4.7,7.84-4.7,7.84l-13.59-3.65L802,751.48l-1.91-1.84-5.44-5.19L790,740l.23-2.5,0-.38a141.85,141.85,0,0,1,4.26-15.88c0-.14.09-.29.14-.43,3.77-11.32,10.06-25.07,19.12-29.16.69-.31,1.41-.61,2.18-.88l.92-.32c17.38-5.82,50.22-3.51,50.22-3.51s25.08,7.32,27.18,10.46,25.87,29,25.87,29a39,39,0,0,1,5.74,5.31C928.09,734.18,930.16,737.29,930.62,740.5Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.93,
    cy: 718.44,
    rx: 7.32,
    ry: 11.5,
    fill: "#fff",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M818.25,695.55s-6,9.2-12.34,21a.41.41,0,0,0,0,.09c-1.69,3.14-3.41,6.45-5.05,9.84l-.07.16s-3.47-2.75-6.2-5.43c0-.14.09-.29.14-.43,3.77-11.32,10.06-25.07,19.12-29.16.69-.31,1.41-.61,2.18-.88Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M800.48,726.39s37.11,11,44.42,6.27c0,0,2.62-33.45-14.63-35.54,0,0-9.93-2.62-12-1S800.48,726.39,800.48,726.39Z",
    transform: "translate(-53 -45.06)",
    fill: "#fff",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M848.56,701.82s7.32,27.7,12.55,28.23,58-.53,55.92-4.19-25.09-27.17-25.09-27.17Z",
    transform: "translate(-53 -45.06)",
    fill: "#fff",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M839.58,751.94s9.5-12.49,26.23.06,6.79,35.54,0,36.06S846,789.11,846,789.11,825.37,780.63,839.58,751.94Z",
    transform: "translate(-53 -45.06)",
    fill: "#192534"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M938.25,755.12a15.14,15.14,0,0,0-20.47-8.78,29.27,29.27,0,0,0-5.28,3.21c-14.89,11.16-6,31.63,0,32.1,2.17.16,5.06.33,7.87.48a18.62,18.62,0,0,0,19.14-22.74A39.18,39.18,0,0,0,938.25,755.12Z",
    transform: "translate(-53 -45.06)",
    fill: "#192534"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 790.86,
    cy: 724.71,
    rx: 7.32,
    ry: 11.5,
    fill: "#fff",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M864.24,747.82s-1-15.16,15.16-8.89S885.15,752,885.15,752Z",
    transform: "translate(-53 -45.06)",
    fill: "#fff",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M930.62,740.5v2.09l-2.61,1-5.33-1s-1.14-8.56,3.23-11C928.09,734.18,930.16,737.29,930.62,740.5Z",
    transform: "translate(-53 -45.06)",
    fill: "#fff",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M930.62,740.6v4.08s-68,4.7-75.26,4.7h-.06c-3.76-2-7.52-2.89-10.68-1.56a11.69,11.69,0,0,0-2.69,1.56c-.24.19-.47.39-.69.59a14.26,14.26,0,0,0-2.56,3.12C834,760.66,835,772.38,835,772.38c-13.59,4.18-27.7-6.79-27.7-6.79-2.56-7.68-4.95-12.69-7.14-16-2-3-3.82-4.47-5.44-5.19L790,740l.23-2.5,37.93,27.58s3.66-23.52,12-21.95,25.09,1.57,25.09,1.57Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M787.93,737.36s-3.14,7.84,0,8.37,10.19-6,19.34,21.43c0,0,14.11,11,27.7,6.79,0,0-1.62-19.86,9.65-24.57s30.07,18.82,30.07,18.82v5.23l44.43-4.71s13.59-10.45,13.07-26.65l-66.9,4.18s-16.73,0-25.09-1.57-12,22-12,22Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 518.81,
    y: 549.35,
    width: 55.93,
    height: 55.93,
    rx: 27.96,
    fill: "#192534"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M585.13,694.34c3.75-3.29,7.56-6.64,10.26-10.83,2.48-3.84,3.94-8.23,5.31-12.59q5.87-18.69,10.11-37.85c-15.39-2.35-26.88-15.94-41.93-19.93-.36-.1-11.87,69.06-12.71,75.38-.69,5.22-6.65,30.15.14,30.29,3.63.08,11.21-9,13.89-11.39Z",
    transform: "translate(-53 -45.06)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M585.13,694.34c3.75-3.29,7.56-6.64,10.26-10.83,2.48-3.84,3.94-8.23,5.31-12.59q5.87-18.69,10.11-37.85c-15.39-2.35-26.88-15.94-41.93-19.93-.36-.1-11.87,69.06-12.71,75.38-.69,5.22-6.65,30.15.14,30.29,3.63.08,11.21-9,13.89-11.39Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M394.94,519.84c-1.7.26-3.5.39-4.9,1.38-2,1.4-2.51,4-3.46,6.26a15.33,15.33,0,0,1-6.05,7c-2.29,1.4-5.08,2.34-6.45,4.64a10.23,10.23,0,0,0-1.07,5,95.89,95.89,0,0,0,.69,15.34c.32,2.55.74,5.15.21,7.66-.61,2.93-2.45,5.42-4.2,7.85-4.2,5.81-8.31,12.19-8.65,19.35-.17,3.6.63,7.29-.28,10.78-1.61,6.19-8.17,10.23-9.45,16.49-.38,1.85-.28,3.81-1,5.54-1.26,3-4.73,4.64-5.62,7.73-.67,2.32.31,4.77.38,7.18.1,3.53-1.75,6.79-3.53,9.83l-10.41,17.7c-3.38,5.74-6.84,11.74-7.41,18.38-.51,5.89,1.32,11.72,3.33,17.28,4.47,12.35,11.11,25.43,23.36,30.18,7.21,2.8,15.24,2.2,22.95,1.56,10.56-.87,21.19-1.76,31.38-4.65,5.05-1.43,10-3.34,15.1-4.36,3.4-.67,6.89-1,10.17-2.09a21,21,0,0,0,13.64-16.5c4.36,1.72,8.4-4,7.78-8.64s-3.74-8.57-5-13.07c-1.8-6.21,0-12.95,3-18.67s7.14-10.78,10.41-16.35a62.29,62.29,0,0,0,7.48-20.16c1.75-9.59,1.22-19.44.68-29.17l-2.06-37.19c-.38-6.81-.81-13.84-3.81-20-3.29-6.71-9.29-11.63-15.28-16.1a254.86,254.86,0,0,0-27.75-18.38c-6.22-3.48-5.78-2.13-10.73,2A27.58,27.58,0,0,1,394.94,519.84Z",
    transform: "translate(-53 -45.06)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M479,623.31c-7.07,5.58-14.23,11.24-19.67,18.42a53.29,53.29,0,0,0-10.68,30.19,93.06,93.06,0,0,0,1.07,15.27c1.07,8.25,3,17.44,9.95,22,4.38,2.87,10.4,3.59,13.39,7.89.94,1.35,1.49,3,2.59,4.19,2,2.16,5.12,2.63,8,2.79a74.15,74.15,0,0,0,12.9-.4c4.89-.59,9.86-1.66,14.7-.74,9.42,1.77,16.45,10.66,26,11.85,7.93,1,15.36-3.61,22-8,6.85-4.53,14-9.38,17.71-16.71,3.61-7.12,3.41-15.5,3.13-23.49-.31-8.87-.63-17.85-3-26.41a46.42,46.42,0,0,1-1.69-6.86c-.71-6,2-11.9,4-17.64,3.11-8.73,4.47-19.49-1.71-26.39-2.61-2.92-6.24-4.72-9.92-6-16.25-5.84-34.19-3.62-50.86-1C501,604.68,491.48,613.48,479,623.31Z",
    transform: "translate(-53 -45.06)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M616.8,588.75c-6.44,9.67-12.9,19.41-17.55,30a193.17,193.17,0,0,0-8,23.6c-6.42,22.19-12.79,44.86-25.61,64.07-1.84,2.76-3.88,5.63-4.07,8.94-.18,3.1,1.3,6,2.73,8.76,3,5.84,6.14,11.74,10.42,16.76s9.4,8.82,14.56,12.7c10.71,8,22.61,16.48,36,15.88,2.77-.13,5.73-.77,7.58-2.84s2.11-4.93,1.78-7.59c-1-8.23-7.2-14.7-12.82-20.8S610.55,725,611,716.68c.35-6.87,4.85-12.73,9.16-18.09,4.93-6.14,9.87-12.27,14.52-18.62,20.11-27.45,34.63-58.66,46.14-90.69,4.85-13.52,9.26-27.72,7.75-42-11-2.7-33-11.72-42.29-2.41-5.63,5.64-9.61,14-14,20.65Z",
    transform: "translate(-53 -45.06)",
    fill: "#fbbebe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M709.68,494.86a171.6,171.6,0,0,0-16.24,38.6c-.93,3.26-1.76,6.7-1.05,10,.77,3.54,3.18,6.45,5,9.57s3.1,7.07,1.45,10.29c-7.8.61-15.53-1.52-23.07-3.63l-23.64-6.6a12.2,12.2,0,0,1-5.35-2.48c-2.74-2.59-2.53-6.94-2-10.66,4.63-30.46,19.5-58.54,25.07-88.83.81-4.37,1.66-9.21,5.14-12,10-7.9,32.64-1.21,37.82,10.23C718.6,462.05,716.23,483.45,709.68,494.86Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M583.13,390.76c-.89.46-1.89,1-2.16,1.94a3.52,3.52,0,0,0,.94,2.83L592,409.73c9.95,14,19.92,28.09,31.43,40.86a221.9,221.9,0,0,0,28.44,26.46c2.88,2.24,5.95,4.57,7.36,7.94a76.53,76.53,0,0,1,3.12-56.77c3.3-7,7.66-13.49,11.09-20.45a2.91,2.91,0,0,0-1.59-4.72c-8.74-4.5-18.3-7.22-27-11.8-6.83-3.6-13-8.28-19.13-12.89-5.47-4.11-12.75-11.37-19.5-13.1-7.29-1.88-7,4.77-9.35,10.32A30.62,30.62,0,0,1,583.13,390.76Z",
    transform: "translate(-53 -45.06)",
    fill: "#fbbebe"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M583.13,390.76c-.89.46-1.89,1-2.16,1.94a3.52,3.52,0,0,0,.94,2.83L592,409.73c9.95,14,19.92,28.09,31.43,40.86a221.9,221.9,0,0,0,28.44,26.46c2.88,2.24,5.95,4.57,7.36,7.94a76.53,76.53,0,0,1,3.12-56.77c3.3-7,7.66-13.49,11.09-20.45a2.91,2.91,0,0,0-1.59-4.72c-8.74-4.5-18.3-7.22-27-11.8-6.83-3.6-13-8.28-19.13-12.89-5.47-4.11-12.75-11.37-19.5-13.1-7.29-1.88-7,4.77-9.35,10.32A30.62,30.62,0,0,1,583.13,390.76Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M645,447.35c-4.57-5.16-10.74-8.57-16.15-12.85-7.78-6.16-13.93-14.1-19.87-22.05-10.9-14.63-21.89-32.55-16.46-50-5.77-.56-10.75,4.18-13.47,9.29s-4.12,10.93-7.51,15.62c-5.15,7.13-13.91,10.45-22.07,13.71a359.68,359.68,0,0,0-51.82,25.75c-6.65,4-13.27,8.29-18.35,14.15-5.44,6.25-8.85,14-13.47,20.85-9,13.47-22.68,23.58-37.86,29.3-5,1.9-10.36,3.38-14.83,6.4-9.58,6.47-13.57,19.37-11.3,30.71s10,21,19.29,27.86S441,567,451.72,571q13.48,4.95,27.13,9.44A155.77,155.77,0,0,0,499.34,586c12.79,2.35,25.94,1.77,38.87,3.2,11.82,1.3,23.43,4.29,35.3,5.12s24.44-.75,34.11-7.66c7.69-5.49,12.81-13.78,17.54-22A598.86,598.86,0,0,0,658,499c2.83-6.67,29.09-44.45,22.55-49.33-32.93-24.57-22,14.47-25.14,11.47C651.21,457.12,648.8,451.64,645,447.35Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M604.21,424.75c-7.07-14.22-11.85-29.44-16.6-44.58-1.31-4.2-2.63-8.74-1.22-12.9,1.7-5,7.14-9.27,5.54-14.28-12.72,4-27.49,10.27-30,23.38-.55,2.86-.45,5.91-1.78,8.49-2.59,5.06-9.19,6.14-14.8,7-16.32,2.61-32.54,9.19-43.72,21.36-1.88,2-3.65,4.27-6,5.77a26.06,26.06,0,0,1-5.39,2.4c-10.94,3.93-22.19,8.83-29.23,18.08-3.63,4.76-5.95,10.47-10,14.89-5.48,6-13.55,9-19.48,14.59-4,3.72-6.85,8.44-9.49,13.21-10.16,18.36-17.61,39.89-12.22,60.18,2.81,10.61,9,20.06,12.33,30.52,4.59,14.25,4.14,30.5,12.75,42.75,5.43,7.7,13.83,12.79,22.43,16.63a120.63,120.63,0,0,0,61,9.82,227.23,227.23,0,0,0,23-3.88c18.13-3.74,36.45-7.81,52.92-16.27,28.09-14.43,48.3-40.22,67.6-65.22,3.67-4.76,7.37-9.56,10-15,2.57-5.19,4.12-10.81,5.85-16.33,5.85-18.61,14.08-37.14,13.31-56.62a16.64,16.64,0,0,0-1.35-6.79c-.78-1.6-2-3-2.69-4.61-1.22-2.88-.67-6.21-1.53-9.22-2.39-8.4-13.43-10-22.17-9.93l-2.8,49.29c-.43,7.4-1.22,15.61-6.73,20.57a14.63,14.63,0,0,1-17.24,1.35c-5.88-3.81-6.71-10.46-6.67-16.83.06-8-.59-15.33-3.14-23C621.41,453.66,611.63,439.7,604.21,424.75Z",
    transform: "translate(-53 -45.06)",
    fill: "#192534"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M607.69,565.21c34.82,17.65,69.84,35.43,101,58.93,7.2,5.42,14.2,11.16,21.81,16,21.81,13.86,48.87,20.61,65.7,40.21,3.54,4.11,6.54,8.73,10.62,12.29a45.77,45.77,0,0,0,11.74,7,103.55,103.55,0,0,0,42.94,8.81c3.87-.05,7.85-.34,11.33-2,9.37-4.54,11.5-16.7,12.45-27.07.32-3.51.39-7.65-2.37-9.83-1.49-1.17-3.46-1.47-5.33-1.76-30.41-4.8-58.47-19.44-83.88-36.83S745,593.27,719.94,575.38c-8.81-6.29-17.83-12.28-26.85-18.27L663.9,537.73c-15.44-10.25-31.7-20.81-50.14-22.74a6.65,6.65,0,0,0-3.14.21c-1.62.63-2.52,2.31-3.31,3.85-5.41,10.54-12,20.11-18.63,29.87-3.55,5.22-3.95,6.57,2.17,9.36C596.36,560.8,602.2,562.43,607.69,565.21Z",
    transform: "translate(-53 -45.06)",
    fill: "#fbbebe"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M676.11,856.44a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-53 -45.06)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 634.05,
    cy: 317.55,
    r: 95.65,
    fill: "#fbbebe"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M611.87,399.91c1.7-8.59,11.56-12.93,20.29-13.51a50.35,50.35,0,0,1,44.92,22.84,70.75,70.75,0,0,0,4.06-16.64l16,1.19a11.08,11.08,0,0,0,5.32-.48c2.06-.92,3.33-3,4.4-5,7-13.07,11.68-29.11,24.82-36l0,18a23.92,23.92,0,0,0,16.83-12.79,70.68,70.68,0,0,0,4.28,14.53c.32.78.77,1.64,1.58,1.84a2.8,2.8,0,0,0,2.16-.79,95.61,95.61,0,0,0,16.51-16l19,32.94a123.74,123.74,0,0,0-53.82-153.09,97.21,97.21,0,0,0-13.71-6.53c-12.37-4.66-25.7-6.15-38.89-7.05-18.75-1.28-38.54-1.23-55,7.76-8.85,4.83-16.2,11.95-23.3,19.11-9.6,9.66-19.2,19.87-24.31,32.5-3.53,8.72-4.74,18.17-5.81,27.51-.65,5.65-1.25,11.49.36,16.94,1.12,3.77,3.23,7.16,4.65,10.83,2.36,6.1,2.73,12.76,3.64,19.24A116.1,116.1,0,0,0,599.64,398c1.5,2.67,3.42,5.51,6.41,6.19s6.58-2.62,5-5.22",
    transform: "translate(-53 -45.06)",
    fill: "#192534"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M611.87,399.91c1.7-8.59,11.56-12.93,20.29-13.51a50.35,50.35,0,0,1,44.92,22.84,70.75,70.75,0,0,0,4.06-16.64l16,1.19a11.08,11.08,0,0,0,5.32-.48c2.06-.92,3.33-3,4.4-5,7-13.07,11.68-29.11,24.82-36l0,18a23.92,23.92,0,0,0,16.83-12.79,70.68,70.68,0,0,0,4.28,14.53c.32.78.77,1.64,1.58,1.84a2.8,2.8,0,0,0,2.16-.79,95.61,95.61,0,0,0,16.51-16l19,32.94a123.74,123.74,0,0,0-53.82-153.09,97.21,97.21,0,0,0-13.71-6.53c-12.37-4.66-25.7-6.15-38.89-7.05-18.75-1.28-38.54-1.23-55,7.76-8.85,4.83-16.2,11.95-23.3,19.11-9.6,9.66-19.2,19.87-24.31,32.5-3.53,8.72-4.74,18.17-5.81,27.51-.65,5.65-1.25,11.49.36,16.94,1.12,3.77,3.23,7.16,4.65,10.83,2.36,6.1,2.73,12.76,3.64,19.24A116.1,116.1,0,0,0,599.64,398c1.5,2.67,3.42,5.51,6.41,6.19s6.58-2.62,5-5.22",
    transform: "translate(-53 -45.06)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M502.09,491.71c3.86,10.61,13.56,17.81,22.76,24.37l24,17.12c6.38,4.55,12.93,9.27,17.08,15.91-6.07,2.3-8.84,10.1-6.85,16.28S566.78,576,573,578s12.82,1.93,19.31,1.56c7.45-.41,15.25-1.31,21.4-5.54L600.2,565.7c-3.56-2.21-7.65-5.73-6.35-9.7l14.25-.14c1.5,0,3.13-.07,4.32-1s1.6-2.36,2.1-3.72a31.55,31.55,0,0,1,26.62-20.08c3.52-.26,7.57-.11,10-2.73,1.58-1.74,1.92-4.24,2.2-6.57.53-4.44,1.05-9,.17-13.35s-3.42-8.67-7.5-10.5c-3-1.36-6.47-1.23-9.75-1.67-15.09-2-25.55-15.68-33.65-28.57s-16.79-27.15-31.23-31.95a50.82,50.82,0,0,0-13.89-2.13c-10.41-.43-21.13.42-30.61,4.74C509.21,446.38,495.21,472.83,502.09,491.71Z",
    transform: "translate(-53 -45.06)",
    fill: "#0284c7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M792.13,372.24l-19-32.94a95.25,95.25,0,0,1-16.51,16,2.77,2.77,0,0,1-2.16.8c-.81-.2-1.26-1.06-1.58-1.84a70.77,70.77,0,0,1-4.28-14.54,23.91,23.91,0,0,1-16.83,12.8l0-18c-13.14,6.91-17.78,22.95-24.82,36-1.07,2-2.34,4.05-4.4,5a11.08,11.08,0,0,1-5.32.48l-16-1.19a70.75,70.75,0,0,1-4.06,16.64,50.35,50.35,0,0,0-44.92-22.84c-8.73.58-18.59,4.92-20.29,13.51l-.85-.94c1.61,2.61-2,5.91-5,5.23s-4.91-3.52-6.41-6.19a116.16,116.16,0,0,1-13.73-40.77c-.91-6.48-1.28-13.14-3.64-19.24-1.42-3.67-3.53-7.06-4.65-10.83,0-.13-.07-.25-.1-.38-.09.75-.18,1.5-.26,2.25-.65,5.66-1.25,11.49.36,17,1.12,3.77,3.23,7.16,4.65,10.82,2.36,6.11,2.73,12.76,3.64,19.25a116,116,0,0,0,13.73,40.76c1.5,2.67,3.42,5.52,6.41,6.2s6.58-2.62,5-5.23l.85.93c1.7-8.58,11.56-12.93,20.29-13.5a50.32,50.32,0,0,1,44.92,22.83,70.55,70.55,0,0,0,4.06-16.63l16,1.18a11,11,0,0,0,5.32-.48c2.06-.92,3.33-3,4.4-5,7-13.08,11.68-29.11,24.82-36l0,18a23.91,23.91,0,0,0,16.83-12.8,71,71,0,0,0,4.28,14.54c.32.77.77,1.64,1.58,1.83a2.73,2.73,0,0,0,2.16-.79,95.25,95.25,0,0,0,16.51-16l19,32.94a124.8,124.8,0,0,0,8.25-55A123.7,123.7,0,0,1,792.13,372.24Z",
    transform: "translate(-53 -45.06)",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.bb3819447396cb634ad8a9fec1438baf.svg";
export { ForwardRef as ReactComponent };